import React, { Fragment } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore, { selectPrincipal } from 'stores/authStore';

/**
 * Wraps protected routes. Redirects to /login if not authenticated.
 * Passes the attempted location via state so LoginPage can redirect back.
 */
export default function ProtectedRoute({ children }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const principal = useAuthStore(selectPrincipal);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // A new principal remounts the console: a mounted query keeps rendering its
  // last result after the cache is cleared, and so does component state.
  return <Fragment key={principal}>{children}</Fragment>;
}
